export default {
  data() {
    return {
      navigation: [
        {
          title: this.$t('Dashboard'),
          name: 'Dashboard',
          icon: 'icon-speedometer',
        },
        {
          title: this.$tc('Marketplaces', 2),
          name: 'Marketplaces',
          icon: 'fa fa-shopping-cart',
          children: [
            {
              title: this.$tc('Marketplaces', 2),
              name: 'MarketplacesMarketplaces',
              icon: 'fa fa-shopping-cart',
            },
            {
              title: this.$tc('Categories', 2),
              name: 'MarketplacesCategories',
              icon: 'fa fa-th-list',
            },
          ],
        },
        {
          title: this.$tc('Products', 2),
          name: 'Products',
          icon: 'fa fa fa-shopping-bag',
          children: [
            {
              title: this.$tc('Colors Maps', 2),
              name: 'ProductsColorsMaps',
              icon: 'fa fa-paint-brush',
            },
            {
              title: this.$tc('Sizes Maps', 2),
              name: 'ProductsSizesMaps',
              icon: 'fa fa-arrows',
            },
          ],
        },
        {
          title: this.$tc('Users', 2),
          name: 'Users',
          icon: 'fa fa-user',
          children: [
            {
              title: this.$tc('Accounts', 2),
              name: 'UsersAccounts',
              icon: 'fa fa-users',
            },
            {
              title: this.$tc('Users', 2),
              name: 'UsersUsers',
              icon: 'fa fa-user',
            },
          ],
        },
      ],
    };
  },
};
